import React from 'react';

import scss from './SectionTitle.module.scss';

function SectionTitle({ title, subtitle, children }) {
  return (
    <div className={scss.wrapper}>
      <div className={scss.titleBlock}>
        {title ? <h3 className={scss.title}>{title}</h3> : null}
        {subtitle ? <span className={scss.subtitle}>{subtitle}</span> : null}
      </div>

      {children ? <div className={scss.actions}>{children}</div> : null}
    </div>
  );
}

export default SectionTitle;
